import { render, staticRenderFns } from "./PazienteDetail.vue?vue&type=template&id=1d155cbc&"
import script from "./PazienteDetail.vue?vue&type=script&lang=ts&"
export * from "./PazienteDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports